export const getUniqValuesBy = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>
>(
  array: Array<T>,
  key?: keyof T
): Array<T> =>
  !key
    ? array.filter((value, index, array) => array.indexOf(value) === index)
    : array.filter((elem, index, array) => {
        const foundIndex = array.findIndex((el) => el[key] === elem[key]);

        return foundIndex === index;
      });
